/**
 * Tolerante Token-Extraktion aus der Login/MFA-Response.
 *
 * Core liefert Tokens nach Spec flach:
 *   { user, accessToken, refreshToken }
 *
 * Aber wir tolerieren auch:
 *   - snake_case (access_token / refresh_token)
 *   - nested tokens-Objekt ({ tokens: { ... } })
 *
 * Wenn beides fehlt → wirft mit aussagekräftiger Fehlermeldung statt
 * stillschweigend `undefined` in den Storage zu schreiben.
 */
export function extractTokens(res, context = 'response') {
  if (!res || typeof res !== 'object') {
    throw new Error(
      `${context}: erwartete ein Token-Objekt, bekam ${typeof res}`,
    );
  }

  const nested = res.tokens && typeof res.tokens === 'object' ? res.tokens : {};

  const accessToken =
    res.accessToken
    ?? res.access_token
    ?? nested.accessToken
    ?? nested.access_token;

  const refreshToken =
    res.refreshToken
    ?? res.refresh_token
    ?? nested.refreshToken
    ?? nested.refresh_token;

  if (typeof accessToken !== 'string' || !accessToken) {
    throw new Error(
      `${context}: kein accessToken in Response gefunden. ` +
        `Keys: [${Object.keys(res).join(', ')}]. ` +
        `Erwartet wurde 'accessToken' (oder access_token / tokens.accessToken).`,
    );
  }
  if (typeof refreshToken !== 'string' || !refreshToken) {
    throw new Error(
      `${context}: kein refreshToken in Response gefunden. ` +
        `Keys: [${Object.keys(res).join(', ')}]. ` +
        `Erwartet wurde 'refreshToken' (oder refresh_token / tokens.refreshToken).`,
    );
  }

  return { accessToken, refreshToken };
}
